package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.radar.dataset.LineProperties
import pl.decks.chartjs.style.BorderCapStyle
import pl.decks.chartjs.style.BorderJoinStyle
import pl.decks.chartjs.value.FillValue

@Suppress("unused")
@RadarDsl
class LinePropertiesScope {
    private var backgroundColor: JSScriptable<ChartColor> = JSScriptable.Static(ChartColor.rgba(0, 0, 0, 0.1f))
    private var borderColor: JSScriptable<ChartColor> = JSScriptable.Static(ChartColor.rgba(0, 0, 0, 0.1f))
    private var borderWidth: JSScriptable<Int> = JSScriptable.Static(3)
    private var borderCapStyle: JSScriptable<BorderCapStyle> = JSScriptable.Static(BorderCapStyle.Butt)
    private var borderJoinStyle: JSScriptable<BorderJoinStyle> = JSScriptable.Static(BorderJoinStyle.Miter)
    private var borderDash: JSScriptable<List<Int>> = JSScriptable.Static(emptyList())
    private var borderDashOffset: JSScriptable<Float> = JSScriptable.Static(0f)
    private var fill: JSScriptable<FillValue> = JSScriptable.Static(FillValue.None)
    var tension: Float = 0f
    var spanGaps: Boolean? = null

    fun backgroundColor(value: ChartColor) { backgroundColor = JSScriptable.Static(value) }
    fun backgroundColor(fn: (dynamic) -> ChartColor) { backgroundColor = JSScriptable.Scriptable(fn) }

    fun borderColor(value: ChartColor) { borderColor = JSScriptable.Static(value) }
    fun borderColor(fn: (dynamic) -> ChartColor) { borderColor = JSScriptable.Scriptable(fn) }

    fun borderWidth(value: Int) { borderWidth = JSScriptable.Static(value) }
    fun borderWidth(fn: (dynamic) -> Int) { borderWidth = JSScriptable.Scriptable(fn) }

    fun borderCapStyle(value: BorderCapStyle) { borderCapStyle = JSScriptable.Static(value) }
    fun borderCapStyle(fn: (dynamic) -> BorderCapStyle) { borderCapStyle = JSScriptable.Scriptable(fn) }

    fun borderJoinStyle(value: BorderJoinStyle) { borderJoinStyle = JSScriptable.Static(value) }
    fun borderJoinStyle(fn: (dynamic) -> BorderJoinStyle) { borderJoinStyle = JSScriptable.Scriptable(fn) }

    fun borderDash(value: List<Int>) { borderDash = JSScriptable.Static(value) }
    fun borderDash(fn: (dynamic) -> List<Int>) { borderDash = JSScriptable.Scriptable(fn) }

    fun borderDashOffset(value: Float) { borderDashOffset = JSScriptable.Static(value) }
    fun borderDashOffset(fn: (dynamic) -> Float) { borderDashOffset = JSScriptable.Scriptable(fn) }

    fun fill(value: FillValue) { fill = JSScriptable.Static(value) }
    fun fill(fn: (dynamic) -> FillValue) { fill = JSScriptable.Scriptable(fn) }

    internal fun build() = LineProperties(
        backgroundColor = backgroundColor,
        borderColor = borderColor,
        borderWidth = borderWidth,
        borderCapStyle = borderCapStyle,
        borderJoinStyle = borderJoinStyle,
        borderDash = borderDash,
        borderDashOffset = borderDashOffset,
        fill = fill,
        tension = tension,
        spanGaps = spanGaps,
    )
}
